<div *ngIf="isAuthenticated | async" class="flex flex-col md:flex-row">
  <div class="md:hidden">
    <div *ngIf="user | async as u" class="flex items-center gap-3 nav-menu-item">
      <app-user-avatar [userId]="u.id" [initials]="u.initials" size="sm"></app-user-avatar>
      <span [ngClass]="{'text-red-500': u.isAdministrator}">{{ u.userName }}</span>
    </div>
    <a class="nav-menu-item" [routerLink]='["/authentication/profile"]'>Profile &amp; photo</a>
    <a class="nav-menu-item" href="/Identity/Account/Manage/ChangePassword">Change Password</a>
    <a class="nav-menu-item" [routerLink]='["/authentication/logout"]' [state]='{ local: true }'>Logout</a>
  </div>
  <div class="hidden md:block">
    <button mat-icon-button class="avatar-button" [matMenuTriggerFor]="menu" [attr.aria-label]="'Account menu for ' + (userName | async)">
      <app-user-avatar *ngIf="user | async as u; else fallbackIcon" [userId]="u.id" [initials]="u.initials" size="nav"></app-user-avatar>
      <ng-template #fallbackIcon>
        <mat-icon aria-hidden="true">account_circle</mat-icon>
      </ng-template>
    </button>
    <mat-menu #menu="matMenu" xPosition="before" class="account-menu">
      <div *ngIf="user | async as u" class="account-menu-header" (click)="$event.stopPropagation()">
        <app-user-avatar [userId]="u.id" [initials]="u.initials" size="lg"></app-user-avatar>
        <div class="min-w-0">
          <div class="account-menu-name" [ngClass]="{'text-red-500': u.isAdministrator}">{{ u.displayName }}</div>
          <div *ngIf="u.displayName !== u.userName" class="account-menu-email">{{ u.userName }}</div>
          <span *ngIf="u.isAdministrator" class="account-menu-role">Administrator</span>
        </div>
      </div>
      <a *ngIf="(hasPhoto | async) === false" mat-menu-item [href]="photoSettingsUrl" class="account-menu-nudge">
        <mat-icon aria-hidden="true">add_a_photo</mat-icon>Add a profile photo
      </a>
      <button mat-menu-item [routerLink]='["/authentication/profile"]'[ngClass]="{'text-red-500 hover:text-red-500': (role | async) === 'Administrator'}">
        <mat-icon aria-hidden="true">person</mat-icon>Profile
      </button>
      <a mat-menu-item href="/Identity/Account/Manage/ChangePassword">
        <mat-icon aria-hidden="true">lock_reset</mat-icon>Change Password
      </a>
      <button mat-menu-item [routerLink]='["/authentication/logout"]' [state]='{ local: true }'>
        <mat-icon aria-hidden="true">power_settings_new</mat-icon>Logout
      </button>
    </mat-menu>
  </div>
</div>
<div *ngIf="!(isAuthenticated | async)">
  <a class="nav-menu-item" [routerLink]='["/authentication/login"]'>Login</a>
</div>
